export default "__VITE_ASSET__D18yhVmq__"